import { _API, _HEADER, _AXIOS_HELPER } from '@/static';
import * as ENUM from "@/enum/lib";

export default {
    login: function (userEmail, userPassword, fcmToken) {
        return new Promise((resolve, reject) => {
            const url = _API + '/user/login';
            const conf = {
                headers: _HEADER()
            };
            const data = {
                userEmail,
                userPassword,
                userType: `manager`,
                fcmToken
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    if (res.data.isSuccess) {
                        // Normalize token shape: token may be string or object; also check headers
                        let tokenBody = undefined;
                        let refreshBody = undefined;
                        try {
                            tokenBody = res.data?.token;
                            if (tokenBody && typeof tokenBody === 'object') {
                                refreshBody = tokenBody.refreshToken;
                                tokenBody = tokenBody.accessToken || tokenBody;
                            }
                        } catch (e) {
                            console.debug('[ACCOUNT.login] token normalization failed', e);
                        }
                        const tokenHeader = res?.headers?.['x-access-token'] || res?.headers?.['X-Access-Token'];
                        const refreshHeader = res?.headers?.['x-refresh-token'] || res?.headers?.['X-Refresh-Token'];

                        const accessTokenToSave = tokenBody || tokenHeader || '';
                        const refreshTokenToSave = refreshBody || refreshHeader || '';

                        // console.debug('[ACCOUNT.login] normalized tokens ->', { accessTokenToSave, refreshTokenToSave });

                        localStorage.setItem('seqUser', res.data.user.seqUser);
                        localStorage.setItem('seqManager', res.data.user.seqManager);
                        localStorage.setItem('userEmail', res.data.user.userEmail);
                        localStorage.setItem('userName', res.data.user.userName);
                        try {
                            localStorage.setItem('accessToken', accessTokenToSave);
                            localStorage.setItem('refreshToken', refreshTokenToSave);
                        } catch (e) {
                            console.debug('[ACCOUNT.login] localStorage.setItem failed', e);
                        }
                        // console.debug('[ACCOUNT.login] stored accessToken:', localStorage.getItem('accessToken'));
                        // console.debug('[ACCOUNT.login] stored refreshToken:', localStorage.getItem('refreshToken'));
                        resolve(res);
                    } else {
                        reject(res.data.failedCode);
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // validateUserId: function (userId) {
    //     return new Promise((resolve, reject) => {
    //         const url = _API + '/user/validUserId';     //API에서 알맞는 PATH를 지정해 줍니다.
    //         const conf = {
    //             headers: _HEADER()
    //         };
    //         const data = { userId };
    //         _AXIOS_HELPER(ENUM.HTTP_METHOD.POST,url, data, conf)
    //             .then( res => {
    //                 resolve( res );
    //             })
    //             .catch( err => {
    //                 reject( err );
    //             });
    //     })
    // },
    validateUserEmail: function (userEmail) {
        return new Promise((resolve, reject) => {
            const url = _API + '/user/validUserEmail';   //API에서 알맞는 PATH를 지정해 줍니다.
            const conf = {
                headers: _HEADER()
            };
            const data = {userEmail};
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        })
    },
    registerUser: function (inputData) {
        return new Promise((resolve, reject) => {
            const url = _API + '/user/signUp';   //API에서 알맞는 PATH를 지정해 줍니다.
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, inputData, conf, true)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        })
    },
    resendAuthEmail: function (inputData) {
        return new Promise((resolve, reject) => {
            const url = _API + '/user/resendAuthEmail';
            const conf = {
                headers: _HEADER()
            };
            const data = {
                userEmail: inputData
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    deleteAccount: function () {
        return new Promise((resolve, reject) => {
            const url = _API + '/manager/deleteManagerAccount';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, {}, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    confirmUserPassword: function (password) {
        return new Promise((resolve, reject) => {
            const url = _API + '/user/confirmUserPassword';
            const conf = {
                headers: _HEADER()
            };
            const data = {password};
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // findUserIdViaEmail: function (userEmail) {
    //     return new Promise((resolve, reject) => {
    //         const url = _API + '/user/findUserIdViaEmail';
    //         const conf = {
    //             headers: _HEADER()
    //         };
    //         const data = { userEmail };
    //         _AXIOS_HELPER(ENUM.HTTP_METHOD.POST,url, data, conf)
    //             .then( res => {
    //                 resolve( res );
    //             })
    //             .catch( err => {
    //                 reject( err );
    //             });
    //     });
    // },
    sendResetPasswordViaEmail: function (inputData) {
        return new Promise((resolve, reject) => {
            const url = _API + '/user/resetManagerPw';
            const conf = {
                headers: _HEADER()
            };
            const data = {
                userEmail: inputData.userEmail
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}